export default {
  namespaced: true,
  state: {
    messengerIsVisible: false,
    unreadMessagesCount: 0,
  },
  mutations: {
    SET_MESSENGER_IS_VISIBLE(state, messengerIsVisible) {
      state.messengerIsVisible = messengerIsVisible;
    },
    SET_UNREAD_MESSAGES_COUNT(state, unreadMessagesCount) {
      state.unreadMessagesCount = unreadMessagesCount;
    },
  },
  getters: {},
  actions: {
    updateMessengerIsVisible: ({ commit }, messengerIsVisible) => {
      commit('SET_MESSENGER_IS_VISIBLE', messengerIsVisible);
    },
    updateUnreadMessagesCount: ({ commit }, unreadMessagesCount) => {
      commit('SET_UNREAD_MESSAGES_COUNT', unreadMessagesCount);
    },
  },
};
